// AppKitProvider.js
import React from "react";
import { createAppKit } from "@reown/appkit/react";
import { WagmiProvider, http } from "wagmi";
import { mainnet, bsc, polygon, arbitrum } from "@reown/appkit/networks";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { WagmiAdapter } from "@reown/appkit-adapter-wagmi";

const queryClient = new QueryClient();

function getProjectId() {
  const fromEnv =
    (typeof process !== "undefined" &&
      process.env &&
      process.env.REACT_APP_REOWN_PROJECT_ID) ||
    "";

  const fromWindow =
    typeof window !== "undefined" ? window.__REOWN_PROJECT_ID__ : "";

  return fromEnv || fromWindow || "";
}

const projectId = getProjectId();

const origin =
  typeof window !== "undefined" ? window.location.origin : "http://localhost:3000";

const metadata = {
  name: "PromosPay",
  description: "AI-Powered Crypto Promotions Platform",
  url: origin,
  icons: [new URL("/logo.png", origin).href],
};

// Сети, которые доступны пользователю в AppKit
export const networks = [mainnet, bsc, polygon, arbitrum];

// RPC по env
const RPC_MAINNET =
  process.env.REACT_APP_RPC_MAINNET ||
  process.env.REACT_APP_RPC_INFURA_FRONT ||
  "";
const RPC_BSC = process.env.REACT_APP_RPC_BSC || "";
const RPC_POLYGON = process.env.REACT_APP_RPC_POLYGON || "";
const RPC_ARBITRUM = process.env.REACT_APP_RPC_ARBITRUM || "";

const wagmiAdapter = new WagmiAdapter({
  networks,
  projectId,
  transports: {
    [mainnet.id]: RPC_MAINNET ? http(RPC_MAINNET) : http(),
    [bsc.id]: RPC_BSC ? http(RPC_BSC) : http(),
    [polygon.id]: RPC_POLYGON ? http(RPC_POLYGON) : http(),
    [arbitrum.id]: RPC_ARBITRUM ? http(RPC_ARBITRUM) : http(),
  },
});

const APPKIT_GUARD_KEY = "__PP_APPKIT_INIT__";

if (typeof window === "undefined" || !window[APPKIT_GUARD_KEY]) {
  if (typeof window !== "undefined") window[APPKIT_GUARD_KEY] = true;

  createAppKit({
    adapters: [wagmiAdapter],
    networks,
    projectId,
    metadata,
    defaultNetwork: mainnet,
    enableNetworkSwitch: true,
    enableReconnect: true,
    allowUnsupportedChain: false,
    features: {
      analytics: false,
      emailShowWallets: true,
    },
    allWallets: "SHOW",
  });
}

export function AppKitProvider({ children }) {
  return (
    <WagmiProvider config={wagmiAdapter.wagmiConfig}>
      <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
    </WagmiProvider>
  );
}
